import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[libTimeInput]',
  standalone: false,
})
export class TimeInputDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    console.log({ event });
    // Allow navigation and control keys.
    const allowedKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'];
    if (allowedKeys.indexOf(event.key) !== -1) {
      return;
    }

    const currentValue: string = this.el.nativeElement.value;
    if (currentValue)
      if (event.key === ':') {
        // Allow colon but only if there isn’t one already.
        if (currentValue.indexOf(':') !== -1) {
          event.preventDefault();
        }
        return;
      }

    // Allow only digits.
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }

    // Optionally enforce maximum length:
    // - When a colon exists, max length is 5 (e.g., "22:15")
    // - When no colon exists, you might want to limit to 4 characters ("5:00" will be 4 after colon insertion)
    if (currentValue.indexOf(':') !== -1 && currentValue.length >= 5) {
      event.preventDefault();
    } else if (currentValue.indexOf(':') === -1 && currentValue.length >= 4) {
      // Allow colon insertion if the user types a fourth character.
      // Otherwise, you might decide to block further digits.
    }
    console.log({ after: this.el.nativeElement.value });
  }
}
